import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/reset.css?vue&type=style&index=0&lang=css"

const __exports__ = script;

export default __exports__